import zhCN from "./en-US";
export default zhCN;